module.exports = __webpack_public_path__ + "static/img/中雪转大雪.ddbbb921.svg";